import { render, staticRenderFns } from "./ModalEditarNotaDePesagem.vue?vue&type=template&id=3e27b6d8&lang=pug"
import script from "./ModalEditarNotaDePesagem.vue?vue&type=script&lang=js"
export * from "./ModalEditarNotaDePesagem.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarNotaDePesagem.vue?vue&type=style&index=0&id=3e27b6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports